var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_724",
    "data-name": "Group 724",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12777",
    "data-name": "Path 12777",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12778",
    "data-name": "Path 12778",
    d: "M25.5,19.448,18.908,8.7a.772.772,0,0,0-.484-.348L11.558,6.76a.77.77,0,0,0-.912.531l-.007.023c-1.1-.735-3.138-1.886-4.53-1.4a1.955,1.955,0,0,0-1.251,1.5A2.159,2.159,0,0,0,5.263,9.34c.813,1.019,2.574,1.533,4.237,1.791l-.87,2.913a.769.769,0,0,0,.082.624l6.59,10.75a.772.772,0,0,0,1.045.264l8.882-5.165a.771.771,0,0,0,.27-1.069M6.066,8.7a1.122,1.122,0,0,1-.209-1.04c.138-.562.4-.713.589-.778.9-.314,2.7.638,3.884,1.467L9.8,10.128C8.243,9.9,6.683,9.473,6.066,8.7M16.223,23.97l-6.017-9.815.849-2.846c.512.04.971.06,1.336.07a1.074,1.074,0,1,0,.376-1.489,1.064,1.064,0,0,0-.425.458c-.3-.01-.632-.027-.984-.052l.558-1.87,5.846,1.352,6.01,9.8Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNew);
export default __webpack_public_path__ + "static/media/icon-new.79b55c6fa28f803f0b389f365ce3008b.svg";
export { ForwardRef as ReactComponent };